


export function getPayoutStatus(item) {
    let status;
    if (item.hostTransaction && item.hostTransaction.id) {
        status = 'Completed';
    } else if (item.hostFailedTransaction && item.hostFailedTransaction.id) {
        status = 'Failed';
    } else if(item.hostPayout == null && item.hostTransaction == null && item.hostFailedTransaction == null) {
        status = 'No payout Method';
    } else if(item.hostTransaction == null && item.hostFailedTransaction == null && item.reservationState == 'completed'){
        status = 'Pending';
    } else if(item.reservationState == 'cancelled' && (item.cancellationDetails.payoutToHost == 0 || item.cancellationDetails.payoutToHost < 0)){
        status = 'Closed'
    } else if(item.reservationState == 'cancelled' && item.cancellationDetails.payoutToHost > 0 && item.hostTransaction == null && item.hostFailedTransaction == null){
        status = 'Pending';
    } else if((item.paymentState == 'pending' || item.paymentState == 'completed') && (item.reservationState == 'approved' || item.reservationState == 'pending')) {
        status = 'Pending';
    } else if (item.reservationState === 'expired' || item.reservationState === 'declined'){
        status = 'Closed'; 
    }

    return status;
}